import React from 'react';
import styled from 'styled-components';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Media } from 'gql/autogen/Media';
import { Box, Icon, MarkerIcon, StaticStep, Typography } from '@drone-js/core';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

export interface SingleDayItineraryProps {
    title: string;
    description?: string;
    duration: string;
    admission: string;
    media?: Media[];
}

interface ItineraryStepProps {
    itinerary: SingleDayItineraryProps;
    cms: CmsValue;
    contentLocale: string;
    isLastStep?: boolean;
}

export const TypographyWhitespacePreWrap = styled(Typography)`
    white-space: pre-wrap;
`;

export const StepperIcon: React.FC<React.ComponentProps<typeof Icon>> = (props) => {
    return (
        <Box display="inline-block">
            <Icon id={props.id} size={props.size} />
        </Box>
    );
};
StepperIcon.displayName = 'StepperIcon';
const ItineraryStep: React.FC<ItineraryStepProps> = (props) => {
    const { itinerary, cms, contentLocale, isLastStep } = props;
    return (
        <StaticStep
            size="s"
            intent="primary"
            hierarchy="tertiary"
            markerContent={<MarkerIcon icon="fill.symbol.pin" />}
            endSlot={
                <Box ps="16">
                    {!!itinerary.title && (
                        <Typography variant="body-s-strong" textColor="deprecated.secondary.interactive" mb="4" lang={contentLocale}>
                            {itinerary.title}
                        </Typography>
                    )}
                    <TypographyWhitespacePreWrap variant="body-s" textColor="base.subtle" lang={contentLocale}>
                        {itinerary.description}
                    </TypographyWhitespacePreWrap>
                    {!!itinerary.duration && (
                        <Typography tag="p" variant="caption-default-strong" textColor="deprecated.secondary.interactive" pt="12" lang={contentLocale}>
                            {cms[130820]} {itinerary.duration}
                        </Typography>
                    )}
                    {!!itinerary.admission && (
                        <Typography tag="p" variant="caption-default-strong" textColor="deprecated.secondary.interactive" lang={contentLocale}>
                            {itinerary.admission}
                        </Typography>
                    )}
                    {!!itinerary.media &&
                        itinerary.media.map((m, i) => {
                            return m.source && <ActivityImage key={i} src={m.source} alt={m.description || `itinerary-image-${i}`} m="8" />;
                        })}
                </Box>
            }
            isLastStep={isLastStep}
        />
    );
};
ItineraryStep.displayName = 'ItineraryStep';

export default ItineraryStep;
